import * as React from "react";

interface ArrowProps {
  direction: "left" | "right";
}

const assetPrefix = process.env.ASSET_PREFIX || "";

export default function Arrow(props: ArrowProps) {
  return (
    <img
      src={`${assetPrefix}/static/chevron-${props.direction}.svg`}
      alt={props.direction}
    />
  );
}
